import { __extends } from "tslib";
import { Event } from './Event';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: TimerEvent
var TimerEvent = /** @class */ (function (_super) {
    __extends(TimerEvent, _super);
    function TimerEvent(type, bubbles, cancelable) {
        return _super.call(this, type, bubbles, cancelable) || this;
    }
    TimerEvent.prototype.clone = function () {
        return new this.sec.flash.events.TimerEvent(this.type, this.bubbles, this.cancelable);
    };
    TimerEvent.prototype.toString = function () {
        return this.formatToString('TimerEvent', 'type', 'bubbles', 'cancelable', 'eventPhase');
    };
    TimerEvent.prototype.updateAfterEvent = function () {
        //release || console.log("TimerEvent.updateAfterEvent not implemented");
        this.sec.player.requestRender();
    };
    TimerEvent.classInitializer = null;
    TimerEvent.classSymbols = null;
    TimerEvent.instanceSymbols = null;
    // JS -> AS Bindings
    TimerEvent.TIMER = 'timer';
    TimerEvent.TIMER_COMPLETE = 'timerComplete';
    return TimerEvent;
}(Event));
export { TimerEvent };
